import { gql } from "@apollo/client"
import { ORDER_DETAIL_FRAG, ORDER_LIST_FRAG } from "./order.fragments.gql"

export const ORDER_LIST = gql`
  query OrderList(
    $query: String
    $first: Int
    $skip: Int
    $filter: OrderFilterInput
  ) {
    allOrders(query: $query, first: $first, skip: $skip, filter: $filter) {
      ...OrderListFrag
    }
  }
  ${ORDER_LIST_FRAG}
`

export const ORDER_DETAIL = gql`
  query OrderDetail($id: ID!) {
    orderDetail(id: $id) {
      ...OrderDetailFrag
    }
    orderInvoiceDetail(orderId: $id) {
      id
      trackingCode
      pocName
      pocNumber
      invoiceItems {
        name
        quantity
        actualRate
        discountedRate
        category
        itemType
        amount
        balance
        itemDiscountId
        itemDiscountCode
        itemDiscountFlat
        itemDiscountPercent
        customDiscountFlat
        customDiscountPercent
      }
      discountCode
      discountPercentage
      deliveryAddress {
        village
        address
      }
      availablePaymentModes
    }
  }
  ${ORDER_DETAIL_FRAG}
`

export const ORDER_INVOICE = gql`
  query OrderInvoice($orderId: ID) {
    orderInvoiceDetail(orderId: $orderId) {
      id
      trackingCode
      pocName
      pocNumber
      invoiceItems {
        name
        quantity
        actualRate
        discountedRate
        category
        itemType
        amount
        balance
        itemDiscountId
        itemDiscountCode
        itemDiscountFlat
        itemDiscountPercent
        customDiscountFlat
        customDiscountPercent
      }
      discountCode
      discountPercentage
      deliveryAddress {
        village
        address
      }
      availablePaymentModes
    }
  }
`
export const VENDORS = gql`
  query allVendorsSelector(
    $group: String
    $first: Int
    $skip: Int
    $query: String
    $departmentId: ID
  ) {
    usersByGroup(
      groupName: $group
      first: $first
      skip: $skip
      query: $query
      departmentId: $departmentId
    ) {
      id
      fullName
      number
      address {
        id
        village
        district
        address
        latitude
        longitude
        taluka
        state
        pincode
        geofenceRadius
      }
    }
  }
`

export const CART_INVOICE = gql`
  query cartInvoice(
    $orderItems: [OrderItemStockInput]!
    $discountId: ID
    $customDiscountPercent: Float
    $customDiscountFlat: Float
  ) {
    customInvoiceDetail(
      orderItems: $orderItems
      discountId: $discountId
      customDiscountPercent: $customDiscountPercent
      customDiscountFlat: $customDiscountFlat
    ) {
      id
      trackingCode
      pocName
      pocNumber
      invoiceItems {
        name
        quantity
        actualRate
        discountedRate
        category
        itemType
        amount
        balance
        stockCount
        itemDiscountId
        itemDiscountCode
        itemDiscountFlat
        itemDiscountPercent
        customDiscountFlat
        customDiscountPercent
      }
      discountCode
      discountPercentage
      deliveryAddress {
        id
        village
        address
      }
      availablePaymentModes
    }
  }
`

export const AGGREGATED_ORDER_ITEMS = gql`
  query AggregatedOrderItems(
    $orderIds: [ID]
    $targetDcId: ID!
    $orderingDcId: ID
    $filter: OrderFilterInput
  ) {
    aggregatedOrderItems(
      orderIds: $orderIds
      targetDcId: $targetDcId
      orderingDcId: $orderingDcId
      filter: $filter
    ) {
      sourceDcRate
      quantity: totalQuantity
      sellableItem {
        id
        name
      }
      stockCount
      orderingItemStock {
        id
      }
      sellableItemStock {
        id
        offerStockCount
        currentStockCount
        unitRate
        discountedRate
        sellableItem {
          id
          name
        }
        distributionCentre {
          id
          name
        }
      }
    }
  }
`
export const ORDERS_BY_SELLABLE_ITEMS = gql`
  query OrdersBySellableItem(
    $query: String
    $first: Int
    $skip: Int
    $filter: OrderFilterInput
  ) {
    ordersBySellableItem(
      query: $query
      first: $first
      skip: $skip
      filter: $filter
    ) {
      sellableItem {
        id
        name
        primaryPhoto {
          id
          url
        }
        shortDescription
        sellableVarieties {
          id
          name
        }
      }
      statusDetails {
        quantity
        orderStatus
      }
    }
  }
`

export const ORDERS_BY_SELLABLE_ITEMS_SUMMARY = gql`
  query OrdersBySellableItemsSummary($filter: OrderFilterInput) {
    summaryAllOrders(filter: $filter) {
      itemCount
      itemStatusConfirmed
      itemStatusCancelledByUser
      itemStatusInProcess
      itemStatusReadyForDespatch
    }
  }
`
export const SUMMARY_ALL_ORDERS = gql`
  query SummaryAllOrders($filter: OrderFilterInput) {
    summaryAllOrders(filter: $filter) {
      statusCompleted
      statusPlaced
      statusConfirmed
      statusNotPlaced
      statusInProcess
      statusPartialReject
      statusFullReject
      statusReadyForDespatch
      statusScheduledForDespatch
      statusReadyForSchedule
      statusDespatched
      statusCancelledByUser
      statusCancelledByVendor
      orderCount
    }
  }
`

export const SUMMARY_ALL_ORDER_ITEMS = gql`
  query SummaryAllOrderItems($filter: OrderFilterInput) {
    summaryAllOrders(filter: $filter) {
      statusCompleted
      statusPlaced
      statusConfirmed
      statusNotPlaced
      statusInProcess
      statusPartialReject
      statusFullReject
      statusReadyForDespatch
      statusScheduledForDespatch
      statusReadyForSchedule
      statusDespatched
      statusCancelledByUser
      statusCancelledByVendor

      itemStatusCompleted
      itemStatusPlaced
      itemStatusConfirmed
      itemStatusNotPlaced
      itemStatusInProcess
      itemStatusPartialReject
      itemStatusFullReject
      itemStatusReadyForDespatch
      itemStatusScheduledForDespatch
      itemStatusReadyForSchedule
      itemStatusDespatched
      itemStatusCancelledByUser
      itemStatusCancelledByVendor

      orderCount
      itemCount
    }
  }
`

export const ORDER_COUNT_FILTER = gql`
  query OrderCountFilter($filter: OrderFilterInput) {
    orderCountFilter(filter: $filter)
  }
`

export const PRINT_ORDER_INVOICE = gql`
  query OrderInvoiceDetail($orderId: ID!, $tripId: ID) {
    orderInvoiceDetail(orderId: $orderId, tripId: $tripId) {
      id
      invoiceDocumentPath
    }
  }
`
